import type { MouseEvent } from "react";
import { BorderIcon } from "@/icons/widget-menu";
import type { ActiveSubMenuState, MenuOptionResult, SetActiveSubMenu } from "../../types";
import styles from "../../WidgetMenu.module.css";

interface UseBorderButtonProps {
    activeSubMenu: ActiveSubMenuState | null;
    setActiveSubMenu: SetActiveSubMenu;
}

export function useBorderButton({
    activeSubMenu,
    setActiveSubMenu,
}: UseBorderButtonProps): MenuOptionResult {
    const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
        const button = event.currentTarget;

        setActiveSubMenu((prev) =>
            prev?.name === "border" ? null : { name: "border", anchor: button },
        );
    };

    const isActive = activeSubMenu?.name === "border";

    return {
        handleClick,
        content: <BorderIcon className={isActive ? styles.borderSvgActive : ""} />,
        isActive,
    };
}
